import { toast, ToastContentProps } from 'react-toastify'

import { ToastContainerEnum } from '@/@types/schemas/toast-containers'

type ToastData = { title: string; text: string }

const Toast = ({ data }: Partial<ToastContentProps<ToastData>>) => {
  if (!data) {
    return null
  }

  const { title, text } = data

  return (
    <div className="flex flex-col">
      <h3 className="text-lg font-bold text-zinc-800">{title}</h3>
      {text && <p className="text-sm text-[#7C8D9F]">{text}</p>}
    </div>
  )
}

const showSuccess = ({
  title,
  description,
  containerId,
}: {
  title: string
  description: string
  containerId: ToastContainerEnum
}) =>
  toast.success(<Toast />, {
    containerId,
    style: {
      minWidth: '25rem',
    },
    data: {
      title,
      text: description,
    },
  })

const showError = ({
  title,
  description,
  containerId,
}: {
  title: string
  description: string
  containerId: ToastContainerEnum
}) =>
  toast.error(<Toast />, {
    containerId,
    style: {
      minWidth: '25rem',
    },
    data: {
      title,
      text: description,
    },
  })

const showWarning = ({
  title,
  description,
  containerId,
}: {
  title: string
  description: string
  containerId: ToastContainerEnum
}) =>
  toast.warning(<Toast />, {
    containerId,
    style: {
      minWidth: '25rem',
    },
    data: { title, text: description },
  })

export { showError, showSuccess, showWarning }
